import * as React from "react";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import "./style.scss";
import { Divider } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import ChatBubbleRoundedIcon from "@mui/icons-material/ChatBubbleRounded";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import Diversity1RoundedIcon from "@mui/icons-material/Diversity1Rounded";
import InterpreterModeRoundedIcon from "@mui/icons-material/InterpreterModeRounded";
import CompareArrowsRoundedIcon from "@mui/icons-material/CompareArrowsRounded";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";

const UserLayout = (props) => {
  const { open } = props;
  const location = useLocation();
  const isAdminLogin =
    location && location.pathname && location.pathname.includes("admin");

  let sideMenu = [
    {
      title: "Home",
      icon: <DashboardIcon />,
      path: "home",
      role: "USER",
    },
    {
      title: "Wish List",
      icon: <FavoriteRoundedIcon />,
      path: "wishlist",
      role: "USER",
    },
    {
      title: "Chat",
      icon: <ChatBubbleRoundedIcon />,
      path: "chat",
      role: "USER",
    },
    {
      title: "Edit Profile",
      icon: <CreateRoundedIcon />,
      path: "edit-profile",
      role: "USER",
    },
    {
      title: "Edit Preference",
      icon: <EditNoteRoundedIcon />,
      path: "edit-preference",
      role: "USER",
    },
    {
      title: "Profile Viewed",
      icon: <VisibilityRoundedIcon />,
      path: "profile-viewed",
      role: "USER",
    },
    {
      title: "Subscribe",
      icon: <Diversity1RoundedIcon />,
      path: "subscribe",
      role: "USER",
    },
    {
      title: "Profile Assist",
      icon: <InterpreterModeRoundedIcon />,
      path: "profile-assist",
      role: "USER",
    },
    {
      title: "Compare Profile",
      icon: <CompareArrowsRoundedIcon />,
      path: "compare-profile",
      role: "USER",
    },
    {
      title: "Admin Dashboard",
      icon: "https://cdn.lordicon.com/imamsnbq.json",
      path: "admin-dashboard",
      role: "SUPER_ADMIN",
    },
    {
      title: "Sub-Ordinates",
      icon: "https://cdn.lordicon.com/eszyyflr.json",
      path: "sub-ordinates",
      role: "SUPER_ADMIN",
    },
    {
      title: "Associates",
      icon: "https://cdn.lordicon.com/imamsnbq.json",
      path: "associates",
      role: "SUPER_ADMIN",
    },
    {
      title: "Search By Partner",
      icon: <PersonSearchRoundedIcon />,
      path: "search-by-partner",
      role: "USER",
    },
  ];
  let createSideMenu = [
    {
      title: "Create Assosiate",
      icon: "https://cdn.lordicon.com/wloilxuq.json",
      path: "admin/create-assosiate",
      role: "SUPER_ADMIN",
    },
    {
      title: "Create SubOrdinate",
      icon: "https://cdn.lordicon.com/wloilxuq.json",
      path: "admin/create-subordinate",
      role: "SUPER_ADMIN",
    },
  ];

  return (
    <Box>
      {sideMenu.map((menu, index) =>
        menu.role === "USER" ? (
          <NavLink
            to={menu.path}
            className={({ isActive }) => (isActive ? "activeRoute" : "routes")}
            key={index}
          >
            <ListItem key={menu.title} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  padding: 0,
                  gap: 1,
                }}
              >
                <Tooltip title={menu.title} placement="right">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "15px",
                    }}
                    color={"primary"}
                  >
                    {menu.icon}
                  </Box>
                  {/* <lord-icon
                    src={menu.icon}
                    trigger="loop"
                    colors="primary:#121331,secondary:#d53833"
                    style={{
                      width: open ? "60px" : "500px",
                      marginLeft: open ? "auto" : "10px",
                    }}
                  ></lord-icon> */}
                </Tooltip>

                <ListItemText
                  className="menu-text"
                  primary={menu.title}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          </NavLink>
        ) : null
      )}
      {isAdminLogin &&
        createSideMenu.map((menu, index) =>
          menu.role === "SUPER_ADMIN" ? (
            <NavLink
              to={menu.path}
              className={({ isActive }) =>
                isActive ? "activeRoute" : "routes"
              }
              key={index}
            >
              <Divider />
              <ListItem
                key={menu.title}
                disablePadding
                sx={{ display: "block" }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    padding: 0,
                  }}
                >
                  <Tooltip title={menu.title} placement="right">
                    <lord-icon
                      src={menu.icon}
                      trigger="loop"
                      colors="primary:#121331,secondary:#d53833"
                      style={{
                        width: open ? "60px" : "500px",
                        marginLeft: open ? "auto" : "10px",
                      }}
                    ></lord-icon>
                  </Tooltip>

                  <ListItemText
                    className="menu-text"
                    primary={menu.title}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </NavLink>
          ) : null
        )}
    </Box>
  );
};

export default UserLayout;
